interface Environment {
  VITE_AAD_TENANT_ID: string;
  VITE_DIGIASSIST_APP_CLIENT_ID: string;
  VITE_APP_API_BASE_URL: string;
  VITE_APP_VERSION: string;
  REACT_APP_SCOPE: string;
}

const getEnvironment = (): Environment => {
  const env = import.meta.env;

  return {
    VITE_AAD_TENANT_ID: env.VITE_AAD_TENANT_ID || '',
    VITE_DIGIASSIST_APP_CLIENT_ID: env.VITE_DIGIASSIST_APP_CLIENT_ID || '',
    VITE_APP_API_BASE_URL: env.VITE_APP_API_BASE_URL || '',
    VITE_APP_VERSION: env.VITE_APP_VERSION || 'unknown',
    REACT_APP_SCOPE: env.REACT_APP_SCOPE || '',
  };
};

export const environment = getEnvironment();

// Helper function to check if debug features should be enabled
// This uses Vite's define feature which replaces __IS_PRODUCTION__ at build time
export const isProduction = (): boolean => {
  try {
    return __IS_PRODUCTION__;
  } catch {
    return false;
  }
};
